/* eslint-disable camelcase */
import FuseSplashScreen from '@fuse/core/FuseSplashScreen';
import { withKeycloak } from '@react-keycloak/web';
import * as userActions from 'app/auth/store/actions';
import authService from 'app/services/authService';
import * as Actions from 'app/store/actions';
import { resetNavigation } from 'app/store/actions';
import jwtDecode from 'jwt-decode';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

class Auth extends Component {
  state = {
    waitAuthCheck: true,
  };

  componentDidMount() {
    return Promise.all([this.authCheck()]).then(() => {
      this.setState({ waitAuthCheck: false });
    });
  }

  authCheck = () =>
    new Promise((resolve) => {
      authService.on('onAutoLogin', () => {
        const token = authService.getAccessToken();
        const refreshToken = authService.getRefreshToken();

        if (authService.isAuthTokenValid(token)) {
          const decodedToken = jwtDecode(token);

          this.props.setUserData({
            role: decodedToken?.realm_access?.roles,
            data: {
              displayName: [decodedToken?.name],
              email: [decodedToken?.email],
              photoURL: undefined,
              settings: {},
              shortcuts: localStorage.getItem('BuscarAtalhos') ? JSON.parse(localStorage.getItem('BuscarAtalhos')) : [],
            },
          });

          this.props.resetNavigation();
        } else if (authService.isAuthTokenValid(refreshToken)) {
          authService
            .signInWithToken()
            .then(({ decodedToken: user }) => {
              this.props.setUserData({
                role: user?.realm_access?.roles,
                data: {
                  displayName: [user?.name],
                  email: [user?.email],
                  photoURL: undefined,
                  settings: {},
                  shortcuts: localStorage.getItem('BuscarAtalhos')
                    ? JSON.parse(localStorage.getItem('BuscarAtalhos'))
                    : [],
                },
              });

              this.props.resetNavigation();
              resolve();
            })
            .catch((error) => {
              // this.props.showMessage({ message: error });
              resolve();
            });
        }

        resolve();
      });

      authService.on('onAutoLogout', (message) => {
        if (message) {
          this.props.showMessage({ message });
        }

        this.props.logout();
        authService.logout();

        resolve();
      });

      authService.on('onNoAccessToken', () => {
        resolve();
      });

      authService.on('onNoRefreshToken', () => {
        resolve();
      });

      authService.init((success) => {
        if (!success) {
          resolve();
        }
      });
      return Promise.resolve();
    });

  render() {
    return this.state.waitAuthCheck ? <FuseSplashScreen /> : <>{this.props.children}</>;
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout: userActions.logoutUser,
      setUserDataAuth: userActions.setUserDataAuth,
      showMessage: Actions.showMessage,
      hideMessage: Actions.hideMessage,
      setUserData: userActions.setUserData,
      resetNavigation,
    },
    dispatch
  );
}

export default connect(null, mapDispatchToProps)(withKeycloak(Auth));
